module.exports = __webpack_public_path__ + "static/1334338722.10ba7a74.jpg";